<template>
  <div>
    <Overlay
      :show="showShare"
      v-if="browserType !== 'weixin'"
      @click="showShare = false"
      style="z-index: 2"
    >
    </Overlay>
  </div>
</template>

<script>
import { Image as VImage, Toast, Overlay } from "vant";
import { priceMarkup } from "@/api/forward.js";
export default {
  components: { Overlay },
  data() {
    return {
      urlAddress: null,
      showShare: false,
      browserType: localStorage.getItem("browserType"),
    };
  },
  methods: {
    expandShop() {
      let urlAddress;
      console.log(this.$store.state);
      this.$store.dispatch("app/showLoading");
      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          location.pathname +
          "?customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.href + "?customerId=" + this.$store.state.user.forwardId;
      }
      priceMarkup({ forwardType: "STORE", urlAddress })
        .then(({ data }) => {
          this.$store.dispatch("app/hideLoading");
          // this.showShare = true;
          this.$store.dispatch("sharePoster/show", {
            url: data.url,
            title: this.$store.state.user.userInfoNickname,
            desc: "",
            link: urlAddress,
            imgUrl: this.$store.state.user.userInfoAvatar,
          });
        })
        .catch(() => this.$store.dispatch("app/hideLoading"));

      this.urlAddress = urlAddress;
    },
  },
};
</script>

<style scoped>
::v-deep .van-share-sheet__name {
  font-size: 20px;
}
</style>